import { render, staticRenderFns } from "./ViewMethodAssessmentOfTheRiskOfBias.vue?vue&type=template&id=a1320b44&scoped=true"
import script from "./ViewMethodAssessmentOfTheRiskOfBias.vue?vue&type=script&lang=js"
export * from "./ViewMethodAssessmentOfTheRiskOfBias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1320b44",
  null
  
)

export default component.exports